// src/components/AttendanceCapture.js
import React, { useState } from "react";
import CustomWebcam from "./CustomWebcam";
import axios from "axios";
import { Spinner, Button, Label, Input, FormGroup } from "reactstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const AttendanceCapture = () => {
  const auth = useSelector((state) => state.authentication);
  const navigate = useNavigate();
  //const dispatch = useDispatch();
  const { userData, branchData } = auth;
  const [isUploading, setIsUploading] = useState(false);
  const [uploadStatus, setUploadStatus] = useState("");
  const [capturedImage, setCapturedImage] = useState("");
  const [studentsOptions, setStudentsOptions] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [formData, setFormData] = useState({
    photoKey: "",
  });
  const clearHandler = () => {
    setUploadStatus("");
    setCapturedImage("");
    setStudentsOptions([]);
  };

  // other form data fields
  const handleCapture = async (imageDataUrl) => {
    setUploadStatus("");
    setCapturedImage(imageDataUrl);

    try {
      // Convert Data URL to Blob
      const byteString = atob(imageDataUrl.split(",")[1]);
      const mimeString = imageDataUrl.split(",")[0].split(":")[1].split(";")[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ab], { type: mimeString });
      const file = new File([blob], `capture-${Date.now()}.jpg`, {
        type: mimeString,
      });

      setIsUploading(true);

      // Step 1: Get signed upload URL
      const res = await axios.get(
        `${process.env.REACT_APP_COLLEGE_ERP_API}get-upload-url`,
        {
          params: {
            fileName: file.name,
            folder: "attendance-captures",
            contentType: file.type,
          },
        }
      );

      const { uploadUrl, fileKey } = res.data;

      // Step 2: Upload image to S3
      await axios.put(uploadUrl, file, {
        headers: { "Content-Type": file.type },
      });

      // Step 3: Update formData with photo key
      setFormData({
        ...formData,
        photoKey: fileKey,
      });

      const response = await axios.post(
        `${process.env.REACT_APP_COLLEGE_ERP_API}mark-attendance`,
        {
          branch: userData?.branch, // Replace with actual branch if not available from userData
          photoKey: fileKey,
        }
      );
      console.log("Attendance marked successfully:", response.data);
      const { students } = response.data.student || [];
      //   const { branch, photoKey } = req.body;
      if (students?.length > 1) {
        setStudentsOptions(students);
        alert(
          "Identical faces detected. Please select Student Name for attendance."
        );
        setUploadStatus(
          "Identical faces detected. Please select Student Name for attendance."
        );
        return;
      }
      setUploadStatus("Upload successful.");
      alert("✅ Attendance marked successfully!");
    } catch (err) {
      const errorMessage = err.response?.data?.message || "";

      if (
        errorMessage.includes("E11000") &&
        errorMessage.includes("studentId_1_dateOnly_1")
      ) {
        alert("Attendance already marked for today.");
        setUploadStatus("Attendance already marked for today.");
      } else {
        setUploadStatus("Upload failed. Try again.");
        alert("❌ Failed to mark attendance.");
      }
      console.error("Upload failed:", err);
    } finally {
      setIsUploading(false);
    }
  };
  const handleSelectChange = (e) => {
    const selectedId = e.target.value;
    const student = studentsOptions.find((s) => s._id === selectedId);
    setSelectedStudent(student || null);
  };

  const handleConfirmAttendance = async () => {
    if (!selectedStudent) {
      alert("Please select a student.");
      return;
    }

    const res = await fetch(
      `${process.env.REACT_APP_COLLEGE_ERP_API}mark-attendance-manually`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          branch: userData?.branch,
          studentId: selectedStudent.studentId,
          photoKey: formData.photoKey,
        }),
      }
    );

    const result = await res.json();

    alert(result.message);
    setStudentsOptions([]);
    setSelectedStudent(null);
    setUploadStatus("Attendance confirmed successfully.");
    setCapturedImage("");
  };

  return (
    <div className="d-flex flex-column align-items-center">
      <h5>Capture Attendance Photo</h5>
      <div style={{ marginBottom: "10px", width: "400px" }}>
        Please ensure your face is clearly visible in the frame.
        <CustomWebcam onCapture={handleCapture} clear={clearHandler} />
      </div>
      {isUploading && (
        <Spinner size="md" color="primary">
          {" "}
          <span> </span>
        </Spinner>
      )}
      {uploadStatus && (
        <p
          style={{
            color: uploadStatus.includes("successful") ? "green" : "red",
          }}
        >
          {uploadStatus}
        </p>
      )}
      {capturedImage && (
        <div
          style={{
            marginTop: "10px",
            border: "1px solid #ccc",
            width: "100px",
          }}
        >
          <img src={capturedImage} alt="Captured" width="100" />
        </div>
      )}
      {studentsOptions.length > 0 && (
        <div className="d-flex flex-column align-items-center mt-3">
          <FormGroup>
            <Label for="studentSelect">Select Student</Label>
            <Input
              type="select"
              name="studentSelect"
              id="studentSelect"
              onChange={handleSelectChange}
              defaultValue=""
            >
              <option value="" disabled>
                -- Select Student --
              </option>
              {studentsOptions.map((student) => (
                <option key={student._id} value={student._id}>
                  {student.studentName} ({student.studentId})
                </option>
              ))}
            </Input>
          </FormGroup>

          <Button color="primary" onClick={handleConfirmAttendance}>
            Confirm Attendance
          </Button>
        </div>
      )}
    </div>
  );
};

export default AttendanceCapture;
